import React, { useState } from "react";
import { MessageCircle, X } from "lucide-react";

const initialForm = {
  name: "",
  phone: "",
  city: "",
  concern: "",
};

export default function WhatsAppLeadChat() {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(initialForm);
  const [error, setError] = useState("");

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const cleanedPhone = form.phone.replace(/\D/g, "");
    if (!form.name.trim() || !cleanedPhone || !form.concern.trim()) {
      setError("Please fill name, phone, and concern.");
      return;
    }

    if (cleanedPhone.length < 10 || cleanedPhone.length > 15) {
      setError("Please enter a valid phone number.");
      return;
    }

    setError("");

    const businessNumber = (process.env.REACT_APP_WHATSAPP_NUMBER || "919753346858").replace(/\D/g, "");
    const text = `Hi Ariglo Team,
Name: ${form.name}
Phone: ${cleanedPhone}
City: ${form.city || "Not provided"}
Concern: ${form.concern}`;

    const url = `https://wa.me/${businessNumber}?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank", "noopener,noreferrer");

    setForm(initialForm);
    setOpen(false);
  };

  return (
    <>
      {!open && (
        <button type="button" style={fab} onClick={() => setOpen(true)} aria-label="Open WhatsApp chat">
          <MessageCircle size={22} />
        </button>
      )}

      {open && (
        <div style={panel}>
          <div style={header}>
            <div>
              <strong>Chat on WhatsApp</strong>
              <p style={subText}>Share details, we will help you quickly.</p>
            </div>
            <button type="button" style={iconBtn} onClick={() => setOpen(false)} aria-label="Close chat">
              <X size={18} />
            </button>
          </div>

          <form style={body} onSubmit={handleSubmit}>
            <input
              placeholder="Your Name *"
              value={form.name}
              onChange={(e) => handleChange("name", e.target.value)}
              style={input}
            />
            <input
              placeholder="Phone Number *"
              value={form.phone}
              onChange={(e) => handleChange("phone", e.target.value)}
              style={input}
            />
            <input
              placeholder="City"
              value={form.city}
              onChange={(e) => handleChange("city", e.target.value)}
              style={input}
            />
            <textarea
              placeholder="Tell us your concern *"
              value={form.concern}
              onChange={(e) => handleChange("concern", e.target.value)}
              style={{ ...input, minHeight: "90px", resize: "vertical" }}
            />

            {error ? <p style={errorText}>{error}</p> : null}

            <button type="submit" style={submitBtn}>
              Continue to WhatsApp
            </button>
          </form>
        </div>
      )}
    </>
  );
}

const fab = {
  position: "fixed",
  right: "20px",
  bottom: "20px",
  width: "56px",
  height: "56px",
  borderRadius: "50%",
  border: "none",
  background: "linear-gradient(135deg, var(--brand-main), #6f9279)",
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  boxShadow: "0 10px 24px rgba(0,0,0,0.2)",
  zIndex: 9999,
};

const panel = {
  position: "fixed",
  right: "20px",
  bottom: "90px",
  width: "340px",
  maxWidth: "calc(100vw - 20px)",
  background: "#fff",
  border: "1px solid var(--border-soft)",
  borderRadius: "14px",
  overflow: "hidden",
  boxShadow: "0 16px 36px rgba(0,0,0,0.16)",
  zIndex: 9999,
};

const header = {
  background: "linear-gradient(135deg, var(--brand-main), #5f8469)",
  color: "#fff",
  padding: "12px 14px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: "10px",
};

const subText = {
  marginTop: "3px",
  fontSize: "12px",
  opacity: 0.9,
};

const iconBtn = {
  border: "none",
  background: "transparent",
  color: "#fff",
  cursor: "pointer",
};

const body = {
  padding: "12px",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
};

const input = {
  width: "100%",
  border: "1px solid var(--border-soft)",
  borderRadius: "10px",
  padding: "10px 12px",
  fontSize: "14px",
  outline: "none",
  color: "var(--text-strong)",
  background: "var(--bg-base)",
};

const submitBtn = {
  border: "none",
  borderRadius: "10px",
  background: "linear-gradient(90deg, var(--brand-main), #6f9279)",
  color: "#fff",
  fontWeight: 600,
  padding: "11px 12px",
  cursor: "pointer",
};

const errorText = {
  color: "#b54747",
  margin: 0,
  fontSize: "12px",
};
